import { publicApi } from './api';

export const storyService = {
  async list() {
    const { data } = await publicApi.get('/stories');
    return data;
  },
};
